export const newDataRowAction =(data)=> (dispatch) => {
    dispatch({
     type: 'NEW_DATA_ROW_ACTION',
     payload:data
    })
   }